module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-bright-green-down.76786fe7.svg";